module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-gebaeude-circle-9a50aae8819c6305abf230c0daa3b3fd.svg";